import React from "react";
import Firebase from "../../constants/Firebase";
import AddLinkModal from "../modals/AddLinkModal";

class Label extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	// OPEN LINK MODAL
	openModal() {
		this.setState({
			modalIsOpen: true,
		});
	}

	// CLOSE LINK MODAL
	closeModal() {
		this.setState({
			modalIsOpen: false,
		});
	}

	// DELETE LINK
	async deleteLink(linkID) {
		const requestOptions = {
			method: "DELETE",
			redirect: "follow",
		};

		await fetch(
			`${Firebase.databaseURL}/users/${this.props.user.localId}/tabs/${this.props.tabID}/categories/${this.props.catID}/labels/${this.props.labelID}/links/${linkID}.json?auth=${this.props.user.idToken}`,
			requestOptions
		)
			// PARSE JSON HTTP RESPONSE TO TRANSFORM INTO JS OBJECT
			.then((response) => response.json())
			.then((result) => {
				// console.log(result);
			})
			.catch((error) => console.log("error:", error));
		// FETCH AFTER DELETE TO REFRESH CONTENT
		this.props.fetchFirebase();
	}

	render() {
		// GET ARRAY OF KEYS OF LINKS OBJECT
		const linksIDS = this.props.links ? Object.keys(this.props.links) : [];
		// TRANSFORM LINKS OBJECT KEYS INTO LINKS ARRAY WITH IDS
		const links = linksIDS.map((linkID) => {
			return Object.assign({ linkID }, this.props.links[linkID]);
		});

		return (
			<ul className="SubTitle">
				<div className="tab-header-div">
					{/* ADD LINK MODAL */}
					<AddLinkModal
						openModal={this.openModal}
						closeModal={this.closeModal}
						modalIsOpen={this.state.modalIsOpen}
						tabID={this.props.tabID}
						catID={this.props.catID}
						labelID={this.props.labelID}
						fetchFirebase={this.props.fetchFirebase}
						user={this.props.user}
						labTitle={this.props.title}
					/>
				</div>

				{/* LI MAP LINK */}
				{links.map((item, index) => {
					// DESCRIPTION OR URL
					const descriptionURL = item.description ? item.description : item.url;

					return (
						<li className="bookmark-li-el" key={`i${index}`}>
							{/* DELETE LINK BUTTON */}
							<button
								className="modal-button delete-button link-delete-button"
								onClick={(e) => {
									if (
										window.confirm("Are you sure you wish to delete this item?")
									)
										this.deleteLink(item.linkID);
								}}
							>
								<i class="fas fa-circle"></i>
								{/* <i class="far fa-circle"></i> */}
							</button>

							<a
								className="bookmark-link"
								href={item.url}
								target="_blank"
								rel="noopener noreferrer"
								title={descriptionURL}
							>
								{item.name}
							</a>
						</li>
					);
				})}
			</ul>
		);
	}
}

export default Label;
